<template>
  <div>
    <a-drawer :title="`${actType}商品`" :width="850" :visible="showCreateProductForm" :body-style="{ paddingBottom: '80px' }"
      @close="close">

      <a-form-model ref="form"  :model="model" :rules="rules" >

        <a-spin :spinning="loading" tip="Loading..." size="large">

        <a-form-model-item label="商品库ID" prop="product_platform_id" help=''  v-if="model.show_type == 1">
          <a-input v-model="model.product_platform_id" placeholder="" @change="changePlatformId"/>
        </a-form-model-item>

        <template v-else>
          <a-form-model-item label="商品分类" prop="product_type" >
            <a-select show-search  v-model="model.product_type" :filter-option="filterOption" @change="changeProductType">
                <a-select-option :value="item.type" v-for="item in product_types" :key="item.type" >
                    {{ item.name }}
                </a-select-option>
            </a-select>
          </a-form-model-item>

          <a-form-model-item label="商品库名" prop="product_platform_id" help="选择商品库分类后可以选择">
            <a-select show-search  v-model="model.product_platform_id" @change="changeSelectPlatformId"   :filter-option="filterOption" :disabled="!model.product_type">
                <a-select-option :value="item.product_platform_id" v-for="item in productConfigs" :key="item.product_platform_id" :advertiser_id="item.advertiser_id" :val="item">
                    {{ item.name }} - {{ item.product_platform_id }}
                </a-select-option>
            </a-select>
          </a-form-model-item>
        </template>
      

          
        <a-form-model-item label="商品类目" prop="dpa_category" help="填写商品库后可选择">
          <a-cascader :options="xcxNavs" v-model="model.dpa_category" :disabled="!model.product_platform_id"/>
        </a-form-model-item>
        
        <a-form-model-item label="是否同步" prop="profession.is_copy" help="开启后会自动同步到其它商品库">
          <a-radio-group v-model="model.is_copy">
            <a-radio-button :value="1">是</a-radio-button>
            <a-radio-button :value="2">否</a-radio-button>
          </a-radio-group>
        </a-form-model-item>

        <a-form-model-item label="字节小程序推广链接" prop="profession.micro_app_link" help='' >
          <a-input v-model="model.profession.micro_app_link" placeholder="" />
        </a-form-model-item>

        <a-form-model-item label="剧名称" prop="name" help='商品名称，可用于动态创意标题或者素材，长度需要小于150'>
          <a-input v-model="model.name" placeholder="最多输入15个字" :maxLength="150"/>
        </a-form-model-item>

        <a-form-model-item label="版权方主体名称" prop="profession.copyright_owner" help='自有版权请填写主体名称，分销请填写原版权方主体名称，例如：xxx股份有限公司'>
          <!-- <a-input v-model="model.profession.copyright_owner" placeholder=""/> -->
          <a-auto-complete :data-source="copyright_owners" v-model="model.profession.copyright_owner" />
        </a-form-model-item>


        <a-form-model-item label="变现模式" prop="profession.has_paid_content">
          <a-radio-group v-model="model.profession.has_paid_content" @change="changePayModel" disabled>
            <a-radio-button value="2">免费</a-radio-button>
            <a-radio-button value="1">付费</a-radio-button>
          </a-radio-group>
        </a-form-model-item>

        
        <a-form-model-item label="是否包含网赚内容" prop="profession.has_motivation_content" v-if="model.profession.has_paid_content == 1">
          <a-radio-group v-model="model.profession.has_motivation_content">
            <a-radio-button :value="1">是</a-radio-button>
            <a-radio-button :value="2">否</a-radio-button>
          </a-radio-group>
        </a-form-model-item>


        <a-form-model-item label="短剧男女频" prop="profession.playlet_gender" help="男频剧指更受男性偏好的短剧，女频剧指更受女性偏好的短剧 ">
          <a-radio-group v-model="model.profession.playlet_gender">
            <a-radio-button value="1">男频</a-radio-button>
            <a-radio-button value="2" >女频</a-radio-button>
            <a-radio-button value="3" >其他</a-radio-button>
          </a-radio-group>
        </a-form-model-item>
         
        <a-form-model-item label="剧类集数" prop="profession.playlet_num" help='请填写该短剧共有多少集'>
          <a-input v-model="model.profession.playlet_num" placeholder=""/>
        </a-form-model-item>

        <a-form-model-item label="单集剧集时长(分钟)" prop="profession.playlet_duration" help='请填写短剧单集时长，单位为分钟，集数时长=总时长/总集数；仅支持整数，数字上限10位数'>
          <a-input v-model="model.profession.playlet_duration" placeholder=""/>
        </a-form-model-item>

        <a-form-model-item label="起始解锁集数" prop="profession.starting_unlock_episode" help='' v-if="model.profession.has_paid_content == 2">
          <a-input v-model="model.profession.starting_unlock_episode" placeholder=""/>
        </a-form-model-item>

        <template v-else>
          <a-form-model-item label="起始付费集数" prop="profession.start_pay_playlet" help=''>
            <a-input v-model="model.profession.start_pay_playlet" placeholder=""/>
          </a-form-model-item>

          <a-form-model-item label="单集价格（元，不含赠送）" prop="price_info.price" help='请填写充值面板中单集标价价格，不含赠送，单位：元'>
            <a-input v-model="model.price_info.price" placeholder=""/>
          </a-form-model-item>
  
          <a-form-model-item label="最高充值档位(元)" prop="profession.max_charge" help='充值面板内的最高金额档位'>
            <a-input v-model="model.profession.max_charge" placeholder=""/>
          </a-form-model-item>

          <a-form-model-item label="最低充值档位(元)" prop="profession.min_charge" help='充值面板内的最低金额档位'>
            <a-input v-model="model.profession.min_charge" placeholder=""/>
          </a-form-model-item>

          <a-form-model-item label="推荐充值档位(元)" prop="profession.recommended_charge" help=''>
            <a-input v-model="model.profession.recommended_charge" placeholder=""/>
          </a-form-model-item>
  
        </template>
      
        <a-form-model-item label="商品图片" prop="image_url" help='支持格式jpg、png，最多可上传1张'>
          <material-select v-model="model.image_url" :filters="{type:2,num:1}" :onlyUrl="true"/>
        </a-form-model-item>
        
      </a-spin>
      </a-form-model>

      <div v-if="showSubmit" :style="{
        position: 'absolute',
        right: 0,
        bottom: 0,
        width: '100%',
        borderTop: '1px solid #e9e9e9',
        padding: '10px 16px',
        background: '#fff',
        textAlign: 'right',
        zIndex: 1,
      }">
        <a-button @click="close" :disabled="loading" :style="{ marginRight: '8px' }">
          取消
        </a-button>
        <a-button type="primary" @click="submit" :disabled="loading">确定</a-button>
      </div>


      <a-modal :visible="showResult" :footer="null" @cancel="closerResult"  centered :title="`批量创建商品结果`" :width="'50%'">
          <div style="min-height:300px">
            <div v-for="(item, index) in result.success" :key="'s' + index">{{ item }}-创建成功</div>
            <div class="text-red" v-for="(item, index) in result.errors" :key="'e' + index">{{ item }}</div>
          </div>
      </a-modal>

    </a-drawer>
  </div>
</template>

<style lang="less" scoped>
@import 'CreateProduct';
</style>

<script>
import CreateProduct from './CreateProduct'

export default CreateProduct
</script>
